export default __webpack_public_path__ + "static/media/logo-orange-mi.80ff596e.png";